import React from "react";
import { Link } from "react-router-dom";
import {
  Droplets,
  Download,
  ArrowRight,
  ShieldCheck,
  FileText,
  Waves,
  GlassWater,
  Factory,
  Building2,
  FlaskConical,
  Recycle,
  Thermometer,
  Trash2,
  Info,
  Mail,
  Scale,
  Scroll,
  FileCheck,
  Handshake,
} from "lucide-react";

const matrices = [
  {
    title: "Aguas superficiales",
    icon: Waves,
  },
  {
    title: "Aguas subterráneas",
    icon: Droplets,
  },
  {
    title: "Aguas potables",
    icon: GlassWater,
  },
  {
    title: "Aguas residuales domésticas (ARD)",
    icon: Building2,
  },
  {
    title: "Aguas residuales no domésticas (ARnD)",
    icon: Factory,
  },
  {
    title: "Aguas residuales industriales (ARI)",
    icon: Factory,
  },
  {
    title: "Plantas de tratamiento de agua potable (PTAP)",
    icon: ShieldCheck,
  },
  {
    title: "Plantas de tratamiento de agua residual (PTAR)",
    icon: Recycle,
  },
  {
    title: "Sistema de tratamiento de aguas (STA)",
    icon: FlaskConical,
  },
  {
    title: "Parámetros in situ",
    icon: Thermometer,
  },
  {
    title: "RESPEL",
    icon: Trash2,
  },
];

const regulations = [
  {
    type: "decreto",
    title: "Decreto 1076 del 26 de mayo del 2015",
    entity: "Ministerio de Ambiente y Desarrollo Sostenible.",
  },
  {
    type: "resolucion",
    title: "Resolución 1256 del 23 de noviembre del 2021",
    entity: "Ministerio de Ambiente y Desarrollo Sostenible.",
  },
  {
    type: "resolucion",
    title: "Resolución 2115 del 22 de junio del 2007",
    entity:
      "Ministerio de la Protección Social y Ministerio de Ambiente, Vivienda y Desarrollo Territorial.",
  },
  {
    type: "resolucion",
    title: "Resolución 1207 del 25 de julio del 2014",
    entity: "Ministerio de Ambiente y Desarrollo Sostenible.",
  },
  {
    type: "resolucion",
    title: "Resolución 1618 del 7 de mayo del 2010",
    entity: "Ministerio de la Protección Social.",
  },
  {
    type: "acuerdo",
    title: "Acuerdo 43 del 17 de octubre del 2006",
    entity: "Corporación Autónoma Regional de Cundinamarca – CAR.",
  },
  {
    type: "resolucion",
    title: "Resolución 631 del 17 de marzo del 2015",
    entity: "Ministerio de Ambiente y Desarrollo Sostenible.",
  },
  {
    type: "resolucion",
    title: "Resolución 12186 del 20 de septiembre de 1991",
    entity: "Ministerio de Salud.",
  },
  {
    type: "resolucion",
    title: "Resolución 699 del 6 de julio del 2021",
    entity: "Ministerio de Ambiente y Desarrollo Sostenible.",
  },
];

const getIcon = (type) => {
  switch (type) {
    case "decreto":
      return <Scroll size={18} stroke="#ee7d32" strokeWidth={2} />;

    case "acuerdo":
      return <Handshake size={18} stroke="#ee7d32" strokeWidth={2} />;

    default:
      return <FileCheck size={18} stroke="#ee7d32" strokeWidth={2} />;
  }
};

const WaterService = () => {
  return (
    <>
      {/* CALIDAD DE AGUA */}
      <section className="py-16 md:py-20 bg-white  overflow-hidden">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">
            <div className="order-2 lg:order-1">
              <div className="flex items-center gap-3">
                <div>
                  <span className="text-[#ee7d32] text-xs sm:text-sm font-bold uppercase tracking-[0.2em]">
                    Servicios de Monitoreo
                  </span>

                  <div className="mt-2 w-16 h-[2px] bg-[#ee7d32]/40 rounded-full" />
                </div>
              </div>

              <h2 className="mt-5 text-3xl sm:text-4xl md:text-5xl font-bold text-[#111827] leading-tight">
                Calidad de Agua
              </h2>

              <div className="mt-6 md:mt-8 space-y-5 md:space-y-7">
                <p className="text-[#374151] text-base md:text-lg leading-7 md:leading-8">
                  Grupo Sierra Alta S.A.S. entiende las implicaciones de los
                  procesos productivos en los recursos naturales, lo que nos
                  lleva a poner a tu disposición ayuda especializada en:
                  monitoreo, análisis de laboratorio, cumplimientos técnicos,
                  interpretación de resultados, mapas y bases de datos.
                </p>

                <p className="text-[#374151] text-base md:text-lg leading-7 md:leading-8">
                  Nuestro equipo de calidad se identifica con ofrecerte el mejor
                  servicio adecuado a la necesidad de tu requerimiento.
                </p>
              </div>

              <div className="mt-8 md:mt-10 flex flex-col sm:flex-row gap-4">
                <a
                  href=""
                  target="_blank"
                  rel="noopener noreferrer"
                  className="group inline-flex items-center justify-center gap-3 bg-[#ee7d32] hover:bg-[#d96d24] text-white px-7 py-4 rounded-lg font-semibold shadow-lg shadow-[#ee7d32]/25 transition-all duration-300 hover:-translate-y-1"
                >
                  <ShieldCheck className="w-5 h-5" color="#ffffff" />

                  <span className="text-white">Ver acreditación</span>

                  <ArrowRight
                    className="w-5 h-5 transition-transform duration-300 group-hover:translate-x-1"
                    color="#ffffff"
                  />
                </a>

                <a
                  href="/Docs/PORTAFOLIO SIERRA ALTA LAA 2026.pdf"
                  download
                  className="group inline-flex items-center justify-center gap-3 border border-[#ee7d32] bg-[#ee7d32]/10 hover:bg-[#ee7d32] px-7 py-4 rounded-lg font-semibold transition-all duration-300 hover:-translate-y-1"
                >
                  <FileText className="w-5 h-5 stroke-[#ee7d32] group-hover:stroke-white transition-colors duration-300" />

                  <span className="text-[#ee7d32] group-hover:text-white transition-colors duration-300">
                    Descargar brochure
                  </span>

                  <Download className="w-5 h-5 stroke-[#ee7d32] group-hover:stroke-white transition-all duration-300 group-hover:translate-y-[2px]" />
                </a>
              </div>
            </div>

            <div className="relative order-1 lg:order-2">
              <div className="absolute -inset-3 md:-inset-4 bg-[#ee7d32]/10 blur-3xl rounded-[50px]" />

              <div className="absolute -top-4 -right-4 w-32 h-32 border border-[#ee7d32]/30 rounded-full" />
              <div className="relative overflow-hidden shadow-2xl group rounded-tl-[90px] rounded-br-[90px] rounded-tr-[28px] rounded-bl-[28px]">
                <img
                  src="/Images/services/enviromental/monitoring/waterservice/labamb_014.webp"
                  alt="Calidad de Agua"
                  className="w-full h-[340px] sm:h-[450px] md:h-[520px] object-cover object-center transition-transform duration-700 group-hover:scale-105"
                />

                <div className="absolute inset-0 bg-gradient-to-t from-black/55 via-black/10 to-transparent" />

                <div className="absolute bottom-4 left-4 right-4 sm:bottom-6 sm:left-6 sm:right-auto">
                  <div className="bg-white/10 backdrop-blur-md border border-white/20 rounded-2xl px-4 py-4 sm:px-5 shadow-xl">
                    <div className="flex items-center gap-3">
                      <div className="w-11 h-11 rounded-xl bg-[#ee7d32] flex items-center justify-center shrink-0">
                        <Droplets className="w-5 h-5" color="white" />
                      </div>

                      <div>
                        <p className="text-white/80 text-xs sm:text-sm">
                          Servicio especializado
                        </p>

                        <h4 className="text-white font-semibold text-sm sm:text-base">
                          Calidad de Agua
                        </h4>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="absolute top-0 right-0 w-28 h-28 bg-[#ee7d32]/20 blur-2xl" />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* MONITOREO */}
      <section className="py-20 bg-[#f5f5f5]">
        <div className="max-w-7xl mx-auto px-6">
          <div className="mb-14">
            <h2 className="text-4xl md:text-5xl font-bold text-black mt-3">
              Monitoreo
            </h2>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 relative">
            <div className="hidden md:block absolute top-1/2 left-0 w-full h-px bg-gradient-to-r from-transparent via-[#ee7d32]/20 to-transparent -translate-y-1/2" />
            <div className="relative">
              <div className="relative bg-white rounded-[32px] p-10 shadow-md border border-black/5 overflow-hidden h-full">
                <div className="relative">
                  <h3 className="text-7xl font-extrabold text-[#ee7d32]">01</h3>

                  <div className="w-14 h-[3px] bg-[#ee7d32] mt-2 mb-5 rounded-full" />

                  <h4 className="text-2xl font-bold text-black">Puntual</h4>

                  <p className="text-black/60 mt-4 leading-relaxed">
                    Monitoreos específicos para evaluación puntual de parámetros
                    ambientales y operacionales.
                  </p>
                </div>
              </div>
            </div>

            <div className="relative">
              <div className="relative bg-white rounded-[32px] p-10 shadow-md border border-black/5 overflow-hidden h-full">
                <div className="relative">
                  <h3 className="text-7xl font-extrabold text-[#ee7d32]">02</h3>

                  <div className="w-14 h-[3px] bg-[#ee7d32] mt-2 mb-5 rounded-full" />

                  <h4 className="text-2xl font-bold text-black">Compuesto</h4>

                  <p className="text-black/60 mt-4 leading-relaxed">
                    Integración de múltiples variables y análisis técnicos en
                    una sola campaña de monitoreo.
                  </p>
                </div>
              </div>
            </div>

            <div className="relative">
              <div className="relative bg-white rounded-[32px] p-10 shadow-md border border-black/5 overflow-hidden h-full">
                <div className="relative">
                  <h3 className="text-7xl font-extrabold text-[#ee7d32]">03</h3>

                  <div className="w-14 h-[3px] bg-[#ee7d32] mt-2 mb-5 rounded-full" />

                  <h4 className="text-2xl font-bold text-black">Integrado</h4>

                  <p className="text-black/60 mt-4 leading-relaxed">
                    Soluciones completas de monitoreo ambiental con enfoque
                    integral y trazabilidad técnica.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* MATRIZ */}
      <section className="relative py-24 bg-white overflow-hidden">
        <div className="absolute top-0 right-0 w-[500px] h-[500px] bg-[#ee7d32]/5 rounded-full blur-3xl" />
        <div className="absolute bottom-0 left-0 w-[400px] h-[400px] bg-[#ee7d32]/5 rounded-full blur-3xl" />

        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="max-w-3xl">
            <span className="inline-flex items-center gap-2 text-[#ee7d32] text-sm font-bold uppercase tracking-[0.2em]">
              <span className="w-10 h-px bg-[#ee7d32]" />
              Matriz de cobertura
            </span>

            <h2 className="mt-5 text-4xl md:text-5xl font-bold text-[#111827] leading-tight">
              Experiencia y capacidad técnica
            </h2>

            <p className="mt-6 text-[#4b5563] text-lg leading-8">
              Contamos con experiencia y capacidad técnica para el monitoreo y
              análisis en diferentes tipos de aguas y matrices ambientales.
            </p>
          </div>

          <div className="mt-16 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-7">
            {matrices.map((item, index) => {
              const Icon = item.icon;

              return (
                <div
                  key={index}
                  className="group relative overflow-hidden rounded-[30px] border border-[#e5e7eb] bg-white p-7 shadow-sm transition-all duration-500 hover:-translate-y-2 hover:shadow-2xl"
                >
                  <div className="absolute -right-10 -top-10 w-32 h-32 bg-[#ee7d32]/10 rounded-full blur-3xl opacity-0 group-hover:opacity-100 transition-all duration-500" />
                  <div className="relative flex items-center gap-5">
                    <div className="w-16 h-16 rounded-2xl bg-gradient-to-br from-[#ee7d32]/15 to-[#ee7d32]/5 border border-[#ee7d32]/10 flex items-center justify-center flex-shrink-0 transition-all duration-500 group-hover:scale-110">
                      <Icon size={30} color="#ee7d32" strokeWidth={2.2} />
                    </div>

                    <div>
                      <h3 className="text-xl font-bold text-[#111827] leading-snug">
                        {item.title}
                      </h3>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </section>

      {/* NORMATIVIDAD */}
      <section className="py-10 bg-[#f5f5f5]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="relative overflow-hidden rounded-[30px] border border-[#ececec] bg-white shadow-[0_8px_30px_rgba(0,0,0,0.04)]">
            <div className="relative px-6 md:px-8 pt-7 pb-4 border-b border-[#f3f4f6]">
              <div className="flex items-start gap-4">
                <div className="relative flex-shrink-0">
                  <div className="absolute inset-0 bg-[#ee7d32]/15 blur-xl opacity-60" />

                  <div className="relative w-12 h-12 rounded-2xl bg-gradient-to-br from-[#fff7f2] to-[#ffe8d9] border border-[#ffd7bf] flex items-center justify-center">
                    <Scale size={22} stroke="#ee7d32" strokeWidth={2} />
                  </div>
                </div>

                <div className="flex-1">
                  <span className="inline-flex items-center rounded-full border border-[#ffd7bf] bg-[#fff4ec] px-3 py-1 text-[11px] font-semibold tracking-wide text-[#ee7d32]">
                    MARCO REGULATORIO
                  </span>

                  <h2 className="mt-2 text-2xl md:text-[30px] font-bold tracking-tight leading-tight text-[#111827]">
                    Normatividad aplicable para la matriz de aguas
                  </h2>

                  <p className="mt-1.5 max-w-3xl text-sm md:text-[15px] leading-6 text-[#6b7280]">
                    Normativa vigente aplicable a monitoreo, control,
                    caracterización y gestión ambiental del recurso hídrico.
                  </p>
                </div>
              </div>
            </div>

            <div className="px-6 md:px-8 pt-4 pb-7">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                {regulations.map((item, index) => (
                  <div
                    key={index}
                    className="group relative overflow-hidden rounded-2xl border border-[#ededed] bg-gradient-to-b from-white to-[#fcfcfc] p-4 transition-all duration-300 hover:-translate-y-1 hover:border-[#ffd7bf] hover:shadow-[0_10px_24px_rgba(238,125,50,0.08)]"
                  >
                    <div className="absolute inset-0 opacity-0 transition duration-500 group-hover:opacity-100 bg-gradient-to-r from-[#fff3eb] to-transparent" />

                    <div className="relative flex items-start gap-3.5">
                      <div className="w-10 h-10 rounded-xl bg-[#fff5ef] border border-[#ffe1cf] flex items-center justify-center flex-shrink-0 transition-all duration-300 group-hover:scale-105">
                        {getIcon(item.type)}
                      </div>

                      <div className="min-w-0">
                        <h3 className="text-[15px] font-semibold leading-5 text-[#111827]">
                          {item.title}
                        </h3>

                        <p className="mt-1.5 text-sm leading-5 text-[#6b7280]">
                          Expedido por {item.entity}
                        </p>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* NORMATIVIDAD - ACLARACIÓN */}
      <section className="py-10 bg-[#f5f5f5]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="bg-[#f9eee7] border-l-4 border-orange-500 rounded-xl shadow-sm">
            <div className="p-6 md:p-7 flex flex-col md:flex-row md:items-center md:justify-between gap-6">
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 flex items-center justify-center">
                  <Info size={24} color="#ee7d32" className="h-12 w-12" />
                </div>

                <div>
                  <h4 className="text-sm font-semibold text-gray-900">
                    Aclaración normativa
                  </h4>

                  <p className="text-sm text-gray-600 leading-relaxed mt-2 max-w-3xl">
                    Las normas a las cuales corresponde la petición están
                    vinculadas a la empresa y al órgano gubernamental
                    competente, aplicándose la normatividad según la entidad
                    reguladora correspondiente.
                  </p>
                </div>
              </div>

              <a
                href="/Docs/PORTAFOLIO SIERRA ALTA LAA 2026.pdf"
                download
                className="inline-flex items-center justify-center gap-2 px-5 py-2.5
          rounded-lg bg-[#ee7d32] text-white text-sm font-medium
          hover:bg-orange-600 transition"
              >
                Descargar brochure
                <Download size={16} color="white" />
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* CTA MONITOREO */}
      <section className="relative py-14 md:py-20 bg-white overflow-hidden">
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="group relative overflow-hidden rounded-[28px] md:rounded-[30px] border border-[#ececec] bg-white shadow-[0_10px_35px_rgba(0,0,0,0.04)] transition-all duration-300 hover:shadow-[0_18px_50px_rgba(0,0,0,0.08)]">
            <div className="absolute top-0 left-0 h-full w-1.5 bg-gradient-to-b from-[#ee7d32] via-orange-400 to-[#ee7d32]" />

            <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-8 px-5 py-7 sm:px-6 md:px-8 md:py-8 lg:px-10 lg:py-10">
              <div className="flex flex-col sm:flex-row items-start gap-5 max-w-3xl">
                <div className="relative flex-shrink-0">
                  <div className="absolute inset-0 bg-[#ee7d32]/20 blur-xl rounded-2xl" />

                  <div className="relative w-12 h-12 md:w-14 md:h-14 rounded-2xl flex items-center justify-center">
                    <Mail
                      size={34}
                      className="md:w-[42px] md:h-[42px] stroke-[#ee7d32] transition-colors duration-300"
                    />
                  </div>
                </div>

                <div className="min-w-0">
                  <span className="inline-flex items-center rounded-full bg-[#ee7d32]/10 border border-[#ee7d32]/20 px-3 py-1 text-[11px] md:text-[12px] font-semibold uppercase tracking-wider text-[#ee7d32]">
                    Asesoría técnica especializada
                  </span>

                  <h3 className="mt-3 text-xl sm:text-2xl md:text-3xl font-bold tracking-tight text-[#111827] leading-tight">
                    ¿Necesitas monitoreo ambiental confiable para tu proyecto?
                  </h3>

                  <p className="mt-3 text-sm md:text-base leading-6 md:leading-7 text-[#6b7280] max-w-2xl">
                    Recibe acompañamiento técnico especializado en monitoreo,
                    control y gestión ambiental con soluciones adaptadas a las
                    necesidades de tu operación.
                  </p>
                </div>
              </div>

              <div className="flex w-full lg:w-auto">
                <Link
                  to="/contact-us?division=ambiental&service=Monitoreo ambiental"
                  className="group/btn inline-flex w-full sm:w-auto items-center justify-center gap-3 rounded-lg bg-[#ee7d32] px-6 py-3.5 md:px-7 md:py-4 text-sm font-semibold text-white transition-all duration-300 hover:bg-[#e56f20] hover:shadow-lg hover:shadow-[#ee7d32]/20"
                >
                  Contáctanos
                  <ArrowRight
                    size={18}
                    className="transition-transform duration-300 group-hover/btn:translate-x-1"
                    color="white"
                  />
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default WaterService;
